<template>
    <svg version="1.1" class="logo-text" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 57.8 11.1" style="enable-background:new 0 0 57.8 11.1;" xml:space="preserve">
        <path :fill="fill" d="M0,9.2C0,9,0.3,8.8,0.5,9c0.6,0.4,1.3,0.6,2.1,0.6c0.9,0,1.5-0.3,1.5-0.7c0-1-3.6-0.5-3.6-2.9
            c0-1.4,1.3-2.4,3.4-2.4c0.9,0,1.7,0.2,2.3,0.5c0.1,0.1,0.2,0.2,0.2,0.3c0,0.3-0.1,0.7-0.1,1.1c0,0.2-0.3,0.4-0.5,0.2
            C5.1,5.3,4.5,5.1,3.8,5.1c-0.9,0-1.4,0.3-1.4,0.6c0,1,3.6,0.4,3.6,2.8c0,1.5-1.4,2.5-3.6,2.5c-0.9,0-1.8-0.2-2.5-0.5"/>
        <path :fill="fill" d="M7.2,3.8h1.5C8.9,3.8,9,3.9,9.1,4l0.6,3.7c0,0.2,0.3,0.2,0.4,0l1.6-3.6C11.7,4,11.8,3.9,12,3.9h1.3
            c0.2,0,0.3,0.1,0.3,0.3l0.7,3.5c0,0.2,0.3,0.2,0.4,0L16.1,4c0-0.1,0.2-0.2,0.3-0.2h1.4c0.2,0,0.4,0.3,0.3,0.5l-3,6.5
            c-0.1,0.1-0.2,0.2-0.3,0.2h-1.5c-0.2,0-0.3-0.1-0.3-0.3l-0.7-3.4c0-0.2-0.3-0.2-0.3,0l-1.7,3.6c-0.1,0.1-0.2,0.2-0.3,0.2H8.7
            c-0.2,0-0.3-0.1-0.3-0.3L6.9,4.2C6.9,4,7,3.8,7.2,3.8z"/>
        <path :fill="fill" d="M25.4,10.6c0,0.2-0.2,0.3-0.3,0.3c-0.3,0-0.7,0-1,0c-0.2,0-0.3-0.1-0.3-0.3l0-0.9c0,0,0,0,0,0
            c-0.6,0.9-1.6,1.4-2.6,1.4c-1.8,0-2.9-1.3-2.9-3.2c0-2.4,1.8-4.3,4-4.3c1.1,0,1.8,0.5,2.2,1.2c0,0,0,0,0,0c0,0,0.1-0.5,0.2-0.8
            c0-0.2,0.2-0.3,0.3-0.3H26c0.2,0,0.4,0.2,0.3,0.4C26.1,5.4,25.5,9.5,25.4,10.6z M24,7c0-1-0.7-1.7-1.8-1.7c-1,0.1-1.8,0.9-2,1.9
            c-0.2,1.2,0.5,2.1,1.6,2.1C23,9.3,24,8.2,24,7z"/>
        <path :fill="fill" d="M28.9,8c-0.1,0.9,0.4,1.3,1,1.3c0.3,0,0.7-0.1,1-0.2c0.2-0.1,0.5,0.1,0.4,0.4l-0.1,1.1c0,0.1-0.1,0.2-0.2,0.3
            c-0.5,0.2-1.2,0.4-1.8,0.4c-1.5,0-2.6-0.9-2.4-2.8l0.8-5.4c0-0.1,0.1-0.2,0.2-0.3l1.4-0.6c0.2-0.1,0.5,0.1,0.5,0.4l-0.2,1.3h2.3
            c0.2,0,0.4,0.2,0.3,0.4l-0.1,1c0,0.2-0.2,0.3-0.3,0.3h-2.4L28.9,8z"/>
        <path :fill="fill" d="M34.3,7.6c0,1,0.7,1.7,1.8,1.7c0.6,0,1.1-0.1,1.6-0.4c0.2-0.1,0.5,0.1,0.5,0.3l-0.2,1.1c0,0.1-0.1,0.2-0.2,0.3
            c-0.7,0.3-1.4,0.5-2.2,0.5c-2.2,0-3.5-1.5-3.5-3.4c0-2.4,2-4.1,4.5-4.1c0.8,0,1.5,0.2,2,0.5c0.1,0.1,0.2,0.2,0.1,0.3l-0.2,1.2
            c0,0.2-0.3,0.4-0.5,0.2c-0.5-0.3-1-0.5-1.6-0.5C35.3,5.4,34.3,6.2,34.3,7.6z"/>
        <path :fill="fill" d="M46.7,6.2L46,10.6c0,0.2-0.2,0.3-0.3,0.3h-1.3c-0.2,0-0.4-0.2-0.3-0.4l0.5-3.5c0.2-1.2-0.4-1.6-1.1-1.6
            c-0.7,0-1.6,0.4-1.7,1.6l-0.5,3.6c0,0.2-0.2,0.3-0.3,0.3h-1.3c-0.2,0-0.4-0.2-0.3-0.4l1.4-10.2C40.7,0.1,40.8,0,41,0h1.3
            c0.2,0,0.4,0.2,0.3,0.4L42,4.7c0.4-0.5,1.1-1.1,2.4-1.1C45.8,3.6,46.9,4.5,46.7,6.2z"/>
        <path :fill="fill" d="M51.7,9.6l-0.1,1c0,0.1-0.1,0.2-0.2,0.3c-0.4,0.2-0.7,0.2-1.2,0.2c-1.2,0-2.1-0.7-1.8-2.2l0.5-3.5h-0.8
            c-0.2,0-0.4-0.2-0.3-0.4l0.1-1c0-0.2,0.2-0.3,0.3-0.3h2.9l-0.7,4.8C50.3,9,50.6,9.3,51,9.3c0.1,0,0.2,0,0.4,0
            C51.6,9.2,51.8,9.4,51.7,9.6z M49.1,1.2c0.2-0.6,0.6-1,1.2-1.1c1-0.1,1.6,0.8,1.1,1.8c-0.2,0.4-0.7,0.7-1.1,0.8
            C49.4,2.7,48.9,2.1,49.1,1.2z"/>
        <path :fill="fill" d="M54.6,8c-0.1,0.9,0.4,1.3,1,1.3c0.3,0,0.7-0.1,1-0.2c0.2-0.1,0.5,0.1,0.4,0.4l-0.1,1c0,0.1-0.1,0.2-0.2,0.3
            c-0.5,0.2-1.2,0.4-1.8,0.4c-1.6,0-2.6-0.9-2.4-2.8l0.8-5.4c0-0.1,0.1-0.2,0.2-0.3l1.4-0.6c0.2-0.1,0.5,0.1,0.5,0.4l-0.2,1.3h2.3
            c0.2,0,0.4,0.2,0.3,0.4l-0.1,1c0,0.2-0.2,0.3-0.3,0.3H55L54.6,8z"/>
    </svg>
</template>

<script>
export default {
    name: "logo-text",
    props: {
        fill: {
            default: '#006CE4',
            type: String,
        },
    },
}
</script>
